// Maximum character lengths for identity attributes, enforced across every input that maps to an
// Active Directory / Microsoft Entra ID attribute. Where an attribute exists in BOTH directories we
// use the LOWEST common limit so writes sync cleanly (see UIVALIDATIONRULES.md for the full schema).
// Keys are the logical field names used by the onboarding / employee / company forms.
export const FIELD_LIMITS = {
  samAccountName: 20,          // sAMAccountName (pre-Win2000 username) — strict
  userPrincipalName: 113,      // UPN — Entra limit (stricter than AD)
  upnPrefix: 64,               // local part of the UPN (maps to mailNickname)
  mailNickname: 64,            // mail alias
  displayName: 256,
  givenName: 64,               // First name
  surname: 64,                 // sn — Last name
  commonName: 64,              // cn
  email: 256,                  // mail
  jobTitle: 64,                // title — AD 64 / Entra 128 -> use 64
  companyName: 64,             // company — AD 64 / Entra 128 -> use 64
  department: 64,
  officeLocation: 128,         // physicalDeliveryOfficeName
  businessPhone: 64,           // telephoneNumber
  mobilePhone: 64,             // mobile
  streetAddress: 1024,         // multi-line
  city: 128,                   // l (locality)
  state: 128,                  // st
  postalCode: 40,
  country: 128,                // co / c
  description: 1024,
  employeeId: 16,              // employeeID (AD)
};

// extensionAttribute1..15 all share the same cap.
for (let i = 1; i <= 15; i++) FIELD_LIMITS[`extensionAttribute${i}`] = 2048;

// maxLength value for an input (undefined when the field is unconstrained).
export const fieldLimit = (key) => FIELD_LIMITS[key];

// Returns the exact required error message when `value` exceeds the limit for `key`, else null.
//   `"First Name" cannot exceed 64 characters.`
export function lengthError(label, value, key) {
  const max = FIELD_LIMITS[key];
  if (max != null && typeof value === "string" && value.length > max) {
    return `"${label}" cannot exceed ${max} characters.`;
  }
  return null;
}

// Validate a list of [labelText, value, key] tuples; returns the first error message, or null.
export function firstLengthError(fields) {
  for (const [label, value, key] of fields) {
    const err = lengthError(label, value, key);
    if (err) return err;
  }
  return null;
}
